import styled from '@emotion/styled';

export const SecondRowWrapper = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(3)};
  position: sticky;
  top: 60px;
  z-index: 10;
  background: ${({ theme }) => theme.colors.neutrals.white};
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
`;
